/* eslint-disable @typescript-eslint/no-floating-promises */
import create from "zustand";

const useStore = create((set, get) => ({
    notification: "",
    notificationVisible: false,
    notificationClosing: false,
    notify: (notification) => {
        set({ notification, notificationVisible: true });
        // Auto close
        setTimeout(() => {
            const { closeNotification } = get();
            set({ notificationClosing: true });
            closeNotification();
        }, 2500);
    },
    closeNotification: () => {
        set({
            notificationClosing: true,
        });
        setTimeout(() => {
            const { hideNotification } = get();
            hideNotification();
        }, 500);
    },
    hideNotification: () => {
        set({
            notification: "",
            notificationVisible: false,
            notificationClosing: false,
        });
    },
}));

export default useStore;
